import produce from 'immer';

import { Vendor } from '@/ux-legacy/components/common/bentoboard/Common/board-types';

import { createAction } from '../context-utils';
import { CommandPaletteType } from './command-palette-types';

export const setCommandPaletteShowAction = createAction<CommandPaletteType>(
  (state: CommandPaletteType, payload: boolean) => {
    return produce(state, (draft) => {
      draft.showCommandPalette = payload;
    });
  },
);

export const setCommandPaletteShowPopupAction = createAction<CommandPaletteType>(
  (state: CommandPaletteType, payload: boolean) => {
    return produce(state, (draft) => {
      draft.showPopUp = payload;
    });
  },
);

export const setCommandPaletteVendorAction = createAction<CommandPaletteType>(
  (state: CommandPaletteType, payload: { owner: Vendor; employee: Vendor[] }) => {
    return produce(state, (draft) => {
      draft.vendor = {
        ...state.vendor,
        ...payload,
      };
    });
  },
);
